export const getLocalDate = (date) => {
  const options = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }

  return new Date(date).toLocaleDateString('ru-RU', options)
}

export const secondsToHMS = (timeInSeconds) => {
  const hours = Math.floor(timeInSeconds / 3600)
  const minutes = Math.floor((timeInSeconds % 3600) / 60)
  const seconds = Math.floor(timeInSeconds % 60)
  const arr = hours ? [hours, minutes, seconds] : [minutes, seconds]
  return arr
      .map(num => String(num).padStart(2, '0'))
      .join(':')
}

export const getTimeLeftInSeconds = (date) => {
  const futureDateTime = new Date(date).getTime()
  const nowDateTime = Date.now()
  const difference = Math.ceil((futureDateTime - nowDateTime) / 1000)

  return difference > 0 ? difference : 0
}
